var ProgressBarStatus;
(function (ProgressBarStatus2) {
  ProgressBarStatus2["success"] = "success";
  ProgressBarStatus2["progress"] = "progress";
  ProgressBarStatus2["error"] = "error";
  ProgressBarStatus2["indeterminate"] = "indeterminate";
})(ProgressBarStatus || (ProgressBarStatus = {}));

export { ProgressBarStatus };
